export default __webpack_public_path__ + "6577ec0bd84d509a0877abf5a5c82915.png";